<script setup lang="ts">
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import useIcons from '@/composables/useIcons'

  import type { PropType } from 'vue'
  import type { OnboardingSurveyAnswerResponseData } from '@/services/interfaces/Auth0'

  const { vectorSeparator } = useIcons()

  defineProps({
    answerResponseData: {
      type: Object as PropType<OnboardingSurveyAnswerResponseData>,
      required: true,
    },
  })
</script>

<template lang="pug">
.onboarding-survey-response-view
  SVGRenderer(:icon='vectorSeparator', width='100%', :stroke-color='"#D0D0D6"', :has-hover='false')
  .response-view-wrapper
    h1.response-emoji {{ answerResponseData.responseEmoji }}
    h2.response-title {{ answerResponseData.responseTitle }}
    h4.response-text {{ answerResponseData.responseText }}
</template>

<style scoped lang="postcss">
  .onboarding-survey-response-view {
    @apply ketch-rounded-normal ketch-mt-c10;

    .response-view-wrapper {
      @apply ketch-flex ketch-flex-col ketch-justify-center ketch-items-center ketch-p-c20;

      .response-emoji {
        @apply ketch-text-[40px] sm:ketch-text-[70px];
      }

      .response-title {
        @apply ketch-font-bold;
      }

      .response-text {
        @apply ketch-text-center;
      }
    }
  }
</style>
